export const COUNTERPARTY_EDITOR_CREATE_FORM_ID = "counterparty-editor-create";
export const COUNTERPARTY_EDITOR_COMPANY_FORM_ID =
    "counterparty-editor-company";
// Used by EditCounterpartyModal (the standalone edit modal, as opposed to the
// Directory drawer) so its form id never collides with a simultaneously
// mounted CounterpartyEditorDrawer instance.
export const COUNTERPARTY_EDIT_MODAL_FORM_ID = "counterparty-edit-modal";
